const { createContext, useState } = require("react");

const FormContext = createContext();

const initialForm = {
  pro_id: null,
  pro_name: "",
  pro_provider: "",
  pro_existences: "",
  pro_date: "",
  pro_description: "",
  pro_category: "",
};

const FormProvider = ({ children }) => {
  const [form, setForm] = useState(initialForm);

  const data = {
    form,
    setForm,
    initialForm,
  };

  return <FormContext.Provider value={data}>{children}</FormContext.Provider>;
};

export { FormProvider };
export default FormContext;
